module.exports = __webpack_public_path__ + "static/media/Flow-Mobile-Banking.42213bc1.png";